module.exports = __webpack_public_path__ + "./img/profile.41414d50aa7ae3af4f64226a250121cb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/profile.png
// module id = ./assets/images/profile.png
// module chunks = 0